export default "__VITE_ASSET__BzFmi6cX__"